const COPY_SUFFIX_REGEX = /\s*\(Copy\)(?:\s+(\d+))?$/i;

export const getDuplicateBaseName = (title = '') => {
  const trimmedTitle = title.trim();
  if (!trimmedTitle) return 'Untitled Study';
  if (COPY_SUFFIX_REGEX.test(trimmedTitle)) {
    return trimmedTitle.replace(COPY_SUFFIX_REGEX, ' (Copy)');
  }
  return `${trimmedTitle} (Copy)`;
};

export const getNextDuplicateName = (originalTitle = '', existingTitles = []) => {
  const baseName = getDuplicateBaseName(originalTitle);
  const normalizedTitleSet = new Set(
    existingTitles
      .map((title) => (typeof title === 'string' ? title.trim().toLowerCase() : ''))
      .filter(Boolean),
  );

  if (!normalizedTitleSet.has(baseName.toLowerCase())) {
    return baseName;
  }

  let copyNumber = 2;
  while (normalizedTitleSet.has(`${baseName} ${copyNumber}`.toLowerCase())) {
    copyNumber += 1;
  }
  return `${baseName} ${copyNumber}`;
};
